import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalService } from '../global.service';

@Injectable({
  providedIn: 'root'
})
export class AdsaptiveService {

  constructor(
    private http: HttpClient,
    private global: GlobalService
  ) { }

  public getHeaders() {
    return this.http.get<any>(`${this.global.relativeUrl}/headers`, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  public getByIP(userIp: string) {
    return this.http.get<any>(`${this.global.relativeUrl}/get-hotdata/WEB:${this.global.hostName()}:IP:${userIp}`, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  public triggerPixel(urlParams: string) {
    return this.http.get<any>(`${this.global.relativeUrl}/ads-trigger/${urlParams}`, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

}